import { maybeOrgApiBaseUrl, orgApiBaseUrl, orgGatewayUrl } from './orgContext.js';

export const apiBaseUrl = maybeOrgApiBaseUrl();
export const currentApiBaseUrl = () => orgApiBaseUrl();
export const gatewayUrl = (path = '') => orgGatewayUrl(path);

function serviceUrl(serviceName, path = '') {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${orgApiBaseUrl()}${serviceName}/${normalizedPath}`;
}

export const apiRoutes = {
  login: () => serviceUrl('auth-service', '/login'),
  refreshToken: () => serviceUrl('auth-service', '/login/refresh'),
  deviceRefreshToken: () => serviceUrl('auth-service', '/login/refresh?includeRefreshToken=true'),
  logout: () => serviceUrl('auth-service', '/logout'),
  profile: () => serviceUrl('appbackend', '/users/profile'),
  resourceAccess: (resourceId, objectId) =>
    serviceUrl(
      'resource-service',
      `/v2/resources/${encodeURIComponent(resourceId)}/objects/${encodeURIComponent(objectId)}/access`
    ),
  codelyFiles: () => serviceUrl('resource-service', '/v2/codely-files'),
  codelyShares: (owner = null) => {
    const url = serviceUrl('appbackend', '/codely/shares');
    if (owner === null || owner === undefined) {
      return url;
    }
    return `${url}?owner=${encodeURIComponent(owner)}`;
  },
  codelyShare: (shareId) =>
    serviceUrl('appbackend', `/codely/shares/${encodeURIComponent(shareId)}`),
  codelySharePublication: (shareId) =>
    serviceUrl('appbackend', `/codely/shares/${encodeURIComponent(shareId)}/publication`),
  codeExecutions: () => serviceUrl('appbackend', '/code/executions'),
  codeExecution: (codeId) =>
    serviceUrl('appbackend', `/code/executions/${encodeURIComponent(codeId)}`),
  pythonExecutions: () => serviceUrl('appbackend', '/code/python-executions'),
  mlFiles: (userId) => serviceUrl('appbackend', `/users/${encodeURIComponent(userId)}/ml-files`),
  mlFile: (userId, objectId) =>
    serviceUrl(
      'appbackend',
      `/users/${encodeURIComponent(userId)}/ml-files/${encodeURIComponent(objectId)}`
    ),
};
